import React from 'react';
import { Typography, Alert, Box, CircularProgress } from '@mui/material';
import ExtensionIcon from '@mui/icons-material/Extension';

const apiUrl = process.env.REACT_APP_API_URL;

/**
 * Extension Auth page.
 *
 * When the Chrome extension needs a JWT it opens a tab to this page.
 * The extension's auth-bridge content script reads the token from
 * localStorage and the apiUrl from the hidden DOM element, then sends
 * both to the extension's background worker.  Once received, the
 * background worker closes this tab automatically.
 */
const ExtensionAuthPage = () => {
    return (
        <Box sx={{ p: 4, maxWidth: 480 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
                <ExtensionIcon color="primary" />
                <Typography variant="h5">Song Admin Extension</Typography>
            </Box>

            {/* Hidden element the content script looks for */}
            <div
                id="__song_admin_auth__"
                data-api-url={apiUrl}
                style={{ display: 'none' }}
            />

            <Alert severity="info" icon={<CircularProgress size={20} />} sx={{ mb: 2 }}>
                Sharing authentication with the extension&hellip;
            </Alert>
            <Typography variant="body2" color="text.secondary">
                This tab will close automatically once the token is received by the extension.
                If it doesn&rsquo;t close, make sure the Song Admin Extension is installed and enabled.
            </Typography>
        </Box>
    );
};

export default ExtensionAuthPage;
